import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/v1`;

export const CATEGORY_LABELS = {
  treatment_summary: "Resumo do tratamento",
  published_bulletins: "Boletins publicados",
  shareable_medications: "Medicamentos e alterações compartilháveis",
};

/** Rótulos apresentados ao usuário no app Rede de Apoio (categorias técnicas inalteradas). */
export const APOIO_CATEGORY_LABELS = {
  treatment_summary: "Resumo do tratamento",
  published_bulletins: "Boletins",
  shareable_medications: "Medicamentos",
};

export const BULLETIN_SOURCE_LABELS = {
  counselor: "Conselheiro(a)",
  psychologist: "Psicólogo(a)",
  psychiatrist: "Psiquiatra",
};

export const formatApiError = (detail) => {
  if (detail == null) return "Algo não funcionou como esperado. Tente novamente.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
};

export const formatDate = (value) => {
  if (!value) return "—";
  try {
    return new Date(value).toLocaleString("pt-BR", { dateStyle: "short", timeStyle: "short" });
  } catch {
    return value;
  }
};

export const createApi = (namespace) => {
  const storageKey = `erimus_${namespace}_auth`;

  const read = () => {
    try {
      return JSON.parse(localStorage.getItem(storageKey)) || null;
    } catch {
      return null;
    }
  };
  const write = (data) => localStorage.setItem(storageKey, JSON.stringify(data));
  const clear = () => localStorage.removeItem(storageKey);

  const client = axios.create({ baseURL: BASE });

  client.interceptors.request.use((config) => {
    const session = read();
    if (session?.access_token) config.headers.Authorization = `Bearer ${session.access_token}`;
    return config;
  });

  let refreshing = null;
  client.interceptors.response.use(
    (r) => r,
    async (error) => {
      const original = error.config;
      const session = read();
      if (error.response?.status === 401 && session?.refresh_token && !original._retried) {
        original._retried = true;
        try {
          refreshing =
            refreshing ||
            axios.post(`${BASE}/auth/refresh`, { refresh_token: session.refresh_token });
          const { data } = await refreshing;
          refreshing = null;
          write({ ...session, ...data });
          original.headers.Authorization = `Bearer ${data.access_token}`;
          return client(original);
        } catch (e) {
          refreshing = null;
          clear();
        }
      }
      return Promise.reject(error);
    }
  );

  return { client, storageKey, readSession: read, writeSession: write, clearSession: clear };
};
